// extracted by mini-css-extract-plugin
export default {"HtmlCell":"HtmlCell_HtmlCell__u33KF"};